const crudConfig = {
    endpoint: 'criteriaresourceparams',
    functions: {
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['resourceId'],
            query: {
                filter: 'resourceId=#@resourceId@#',
                property: 'queryClass=ByResourceId'
            }
        }
    }
};

export default crudConfig;
